import { Play, Pause, Radar, Clock } from "lucide-react";
import { formatHour } from "../lib/weather";

const DAYS = ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"];
const dayOf = (dt, offset) => new Date((dt + offset) * 1000).getUTCDay();

const fmtTime = (t) => new Date(t * 1000).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });

export const TimelineBar = ({ steps, offset, hourIdx, onChange, playing, onTogglePlay, layer, radar }) => {
  const n = steps.length;
  const todayDay = dayOf(steps[0].dt, offset);
  const segments = [];
  steps.forEach((s, i) => {
    const d = dayOf(s.dt, offset);
    const last = segments[segments.length - 1];
    if (last && last.day === d) last.count += 1;
    else segments.push({ day: d, count: 1, label: d === todayDay ? "Hari Ini" : DAYS[d] });
  });
  const pct = n > 1 ? (hourIdx / (n - 1)) * 100 : 0;

  return (
    <div className="windy-timeline" data-testid="timeline-bar">
      <div className="flex items-center gap-3">
        <button
          data-testid="timeline-play-toggle"
          onClick={onTogglePlay}
          className="h-10 w-10 shrink-0 grid place-items-center rounded-full bg-primary text-primary-foreground shadow-lg"
          title={playing ? "Jeda" : "Putar prakiraan"}
        >
          {playing ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
        </button>

        <div className="flex-1 min-w-0">
          <div className="flex text-[10px] font-semibold uppercase tracking-wider text-muted-foreground mb-1">
            {segments.map((s, i) => (
              <div key={i} style={{ flex: s.count }} className="truncate border-l border-border/60 pl-1.5 first:border-0 first:pl-0">
                {s.label}
              </div>
            ))}
          </div>
          <div className="relative h-7">
            <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-1 rounded-full bg-secondary" />
            <div className="absolute left-0 top-1/2 -translate-y-1/2 h-1 rounded-full bg-primary" style={{ width: `${pct}%` }} />
            <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 flex justify-between pointer-events-none">
              {steps.map((s, i) => (
                <span key={i} className={`h-2 w-px ${i === hourIdx ? "bg-primary" : "bg-border"}`} />
              ))}
            </div>
            <div className="windy-thumb" style={{ left: `${pct}%` }} data-testid="timeline-thumb" />
            <input
              type="range"
              min={0}
              max={n - 1}
              value={hourIdx}
              onChange={(e) => onChange(Number(e.target.value))}
              className="radar-slider windy-range absolute inset-0 w-full"
              data-testid="timeline-slider"
              aria-label="Geser waktu prakiraan"
            />
          </div>
          <div className="flex justify-between text-[10px] text-muted-foreground num mt-0.5">
            {steps.map((s, i) => (
              <span key={i} className={`${i === hourIdx ? "text-foreground font-bold" : ""} ${i % 2 ? "hidden sm:inline" : ""}`}>
                {i === 0 ? "Skrg" : formatHour(s.dt, offset)}
              </span>
            ))}
          </div>
        </div>

        <div className="hidden lg:flex flex-col items-end text-[10px] text-muted-foreground shrink-0 w-28">
          <span className="flex items-center gap-1 text-foreground font-semibold num text-xs" data-testid="timeline-selected-label">
            <Clock className="w-3 h-3 text-primary" />
            {hourIdx === 0 ? "Sekarang" : `${DAYS[dayOf(steps[hourIdx].dt, offset)]} ${formatHour(steps[hourIdx].dt, offset)}`}
          </span>
          <span>Prakiraan 48 jam</span>
        </div>
      </div>

      {layer === "radar" && (
        <div className="mt-2 pt-2 border-t border-border/60 flex items-center gap-3" data-testid="radar-subtimeline">
          <button
            data-testid="radar-play-toggle"
            onClick={() => radar.setPlaying((p) => !p)}
            className="h-7 w-7 shrink-0 grid place-items-center rounded-full glass"
            title="Putar radar"
          >
            {radar.playing ? <Pause className="w-3 h-3" /> : <Play className="w-3 h-3" />}
          </button>
          <Radar className="w-3.5 h-3.5 text-sky-400 shrink-0" />
          <input
            type="range"
            min={0}
            max={Math.max(radar.frames.length - 1, 0)}
            value={radar.idx}
            onChange={(e) => {
              radar.setPlaying(false);
              radar.setIdx(Number(e.target.value));
            }}
            className="radar-slider flex-1"
            data-testid="radar-timeline-slider"
          />
          <span className="text-[10px] num text-muted-foreground shrink-0 w-36 text-right" data-testid="radar-frame-time">
            {radar.current
              ? `Radar ${fmtTime(radar.current.time)}${radar.current.kind === "nowcast" ? " · prakiraan" : ""}`
              : "Memuat radar..."}
          </span>
        </div>
      )}
    </div>
  );
};
